<template>
    <div>
        <v-banner single-line sticky>
            <v-row>
                <v-col>
                    <v-btn
                        color="grey darken-1"
                        dark
                        fab
                        small
                        class="elevation-4"
                        :to="
                            '/Project/ViewCasepending/Odm/' +
                                $route.params.caseid +
                                '/ViewDetail'
                        "
                    >
                        <v-icon>mdi-reply</v-icon>
                    </v-btn>
                </v-col>
                <v-col>
                    <h3 class="pb-2">
                        EDIT CASE | CASEID :
                        {{ showdata.caseid }} | PROJECT : {{ showdata.project }}
                    </h3>
                </v-col>
            </v-row>
        </v-banner>
        <br />
        <v-card>
            <v-form ref="form" v-model="information.valid">
                <v-information
                    :condition="condition"
                    :information="information"
                />
                <!-- <case-information :condition="condition" :information="information" />
        <product-information :information="information" />
        <customer-information :information="information" /> -->
                <engineer-information
                    :condition="condition"
                    :information="information"
                />
                <part-information
                    :condition="condition"
                    :information="information"
                />
            </v-form>
            <v-row justify="center">
                <v-col
                    v-if="showdata.project == 'CDAX'"
                    cols="10"
                    md="4"
                    class="text-center"
                >
                    <v-checkbox
                        v-model="information.skip_ismart"
                        false-value="N"
                        true-value="Y"
                        label="ช่างไม่ต้องปิด iSmart"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-btn
                    :disabled="!information.valid"
                    @click="saveCase()"
                    class="ma-4"
                    tile
                    color="success"
                >
                    <v-icon left>mdi-content-save</v-icon>Save
                </v-btn>
                <!-- <v-btn class="ma-4" tile color="warning">
          <v-icon left>mdi-close-octagon</v-icon>Cancel
        </v-btn>-->
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"

import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import PartInformation from "../components/HpiPartInformation"
import LogInformation from "../components/LogInformation"

import Information from "../components/Information"
import EngineerNewInformation from "../components/EngineerNewInformation"

export default {
    components: {
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "log-information": LogInformation,
        "v-information": Information,
    },
    beforeMount() {
        this.getDetailNew()
    },
    // mounted() {
    //   this.getDetail();
    // },
    data() {
        return {
            closeOnClick: false,
            showdata: {
                caseid: "",
                project: "",
            },
            condition: {
                status: "editcase",
                team: "Odm",
                project: "",
            },
            information: [],
            options: {
                offset: 100,
            },
            lists: [
                {
                    eleId: "#case",
                    eleName: "Case Information",
                },
                {
                    eleId: "#product",
                    eleName: "Products Information",
                },
                {
                    eleId: "#customer",
                    eleName: "Customer Information",
                },
                {
                    eleId: "#lognote",
                    eleName: "Log Note",
                },
                {
                    eleId: "#attach",
                    eleName: "Attachments",
                },
                {
                    eleId: "#parts",
                    eleName: "Parts Information",
                },
                {
                    eleId: "#services",
                    eleName: "Services Information",
                },
                {
                    eleId: "#happycall",
                    eleName: "Happy Call",
                },
                {
                    eleId: "#performance",
                    eleName: "Performance",
                },
            ],
        }
    },
    methods: {
        async saveCase() {
            console.log(this.information)
            console.log(this.information.part)
            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/edit-case/${this.$route.params.caseid}/${this.information.subcase}`

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let { data, status } = await axios.post(
                    url,
                    this.information,
                    options
                )
                if (status == "200") {
                    this.$swal({
                        title: "บันทึกข้อมูลเรียบร้อย",
                        icon: "success",
                        timer: 2000,
                    }).then((del) => {
                        let url =
                            "/Project/ViewCasepending/Odm/" +
                            this.$route.params.caseid +
                            "/ViewDetail"
                        this.$router.push(url)
                    })
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        async getDetailNew() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/edit-case/${this.$route.params.caseid}/${this.$route.params.subcase}`
            try {
                const { data } = await axios.get(`${url}`)

                var part = []

                data.parts.map((res) => {
                    part.push({
                        part_issue_id: res.part_issue_id,
                        ponumber: res.ponumber,
                        part_no: res.part_name,
                        part_desc: res.part_description,
                        rma: res.rma,
                        dateorder: "",
                        dateship: "",
                        status: res.status,
                        remark: res.remark,
                        ce_status: res.ce_status,
                        required_uefi: res.required_uefi,
                        extended_date: res.extended_date,
                        rf_name: res.rf_name,
                        subcase: res.subcase,
                    })
                })

                this.information = {
                    problem_type: [
                        { problem_type_name: "Hardware", problem_type_id: "4" },
                        { problem_type_name: "Software", problem_type_id: "5" },
                        {
                            problem_type_name: "Monitor",
                            problem_type_id: "13",
                        },
                        {
                            problem_type_name: "Toner",
                            problem_type_id: "3",
                        },
                    ],
                    part:
                        part.length != 0
                            ? [...part]
                            : [
                                  {
                                      part_issue_id: "",
                                      ponumber: "",
                                      part_no: "",
                                      part_desc: "",
                                      rma: "",
                                      dateorder: "",
                                      dateship: "",
                                      status: "",
                                      remark: "",
                                      ce_status: "",
                                  },
                              ],
                    ...data,
                }

                this.showdata.caseid = this.information.case_id
                this.showdata.project = this.information.project_name
                this.condition.project = this.information.project_name
            } catch (error) {
                console.log(error)
            }
        },
        gotoLink(eleId) {
            this.$vuetify.goTo(eleId, this.options)
        },
    },
}
</script>
